export default __webpack_public_path__ + "static/claude@2x-1eb528ada3f4453fe8fd91e466859143.png";